import Vue from 'vue';
import moment from 'moment';

export default () => {
  Vue.filter('dateString', (dateTime) => {
    if (!dateTime) return '';
    return moment.utc(dateTime).format('MM/DD/YYYY');
  });
  Vue.filter('dateTimeString', (dateTime) => {
    if (!dateTime) return 'None';
    const localDateTime = moment.utc(dateTime).local();
    return `${localDateTime.format('MM/DD/YYYY')} at ${localDateTime.format('hh:mm A')}`;
  });
  Vue.filter('numberString', (value) => {
    if (!value) return '';
    const number = Number(value);
    return number && number.toLocaleString();
  });
  Vue.filter('emptyOrNot', condition => (condition ? '' : 'NOT '));
  Vue.filter('phoneString', (value) => {
    if (!value) return value;
    const match = value.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return value;
  });
};
